import AddCampaignPage from './AddCampaignPage';

export default AddCampaignPage;
